import React from "react";

const BS5_Spinners = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_Spinners Component</h2>
      <p>This is the BS5_Spinners component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_Spinners;
